module.exports = __webpack_public_path__ + "img/mds.pimprint.9c46ecba.svg";